var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSeatIcon = function SvgSeatIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "4yeoejzava",
    d: "M.012.07h13.636V4.9H.012z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.8 26.6)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cy5zl5r9ab",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4yeoejzava"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.36.177a.638.638 0 0 1-.04-.106H2.772L.012 4.9h13.636L11.36.177z",
    fill: "#164076",
    mask: "url(#cy5zl5r9ab)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m.128 4.86 6.189 19.002c.3.92 1.15 1.537 2.117 1.537h11.79c.554 0 1.061-.282 1.354-.753l1.348-2.166a.666.666 0 0 0 .017-.69.666.666 0 0 0-.594-.349h-11.51l-1.894-4.959a1.18 1.18 0 0 1 1.102-1.6h5.067c.171 0 .31-.139.31-.31v-.928a.309.309 0 0 0-.31-.309H8.556a1.18 1.18 0 0 1-1.103-.758l-.502-1.315a1.02 1.02 0 0 1 .024-.785l.617-1.364a1.02 1.02 0 0 0 .025-.781l-.647-1.71a.377.377 0 0 0-.021-.078L4.734.838A1.321 1.321 0 0 0 3.511 0c-.35 0-.69.143-.936.392L.742 2.252A2.568 2.568 0 0 0 .128 4.86",
    fill: "#164076"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSeatIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/seat-icon.0cbdf46d.svg";
export { ForwardRef as ReactComponent };